import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {SystemUserModel, TenantModel, TenantUserModel} from '@/libs/Api';
import {AdminTenantUsersDataService} from '@/libs/admin-tenant-users/admin-tenant-users-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const adminTenantUsersStore = registerCrudStore<TenantUserModel, TenantUserModel>(BusinessModule.AdminTenantUser, new AdminTenantUsersDataService());
